<template>
    <v-container max-width="100%" style="margin-top: 2%">
  
      <v-container class="toolbar__container">
          <v-form ref="form" v-model="formValidado">
            <v-row>
              <v-col cols="12" sm="12" md="2">
                <LazySelect
                  ref="empresaSelect"
                  get-url="getEmpresaslazy"
                  text="razao_social"
                  value="id_empresa"
                  :label="$tc('company.self', 1)"
                  @input="onEmpresaInput"
                />
              </v-col>
              <!-- adicionar unidade -->
              <v-col cols="12" sm="6" md="3">
                <MultiplaEscolha
                  ref="unidadesSelect"
                  lazy
                  get-url="getUnidadeslazy"
                  :request-data="lazySelectRequestData"
                  :items="semUnidadeOption"
                  v-bind:selected-items.sync="unidadesSelecionadas"
                  text="descricao_unidade"
                  value="id_unidade"
                  :label="$t('nav.registration.units')"
                  :max-items="2"
                />
              </v-col>
              <!-- termina unidade -->
              <v-col cols="12" sm="4" md="3">
                <v-datetime-picker
                  :label="$t('datetime.startDate')"
                  v-model="dti"
                  :time-picker-props="timeProps"
                  :text-field-props="textFieldProps"
                  :date-picker-props="dtiProps"
                  time-format="HH:mm:ss"
                  date-format="dd/MM/yyyy"
                  :clear-text="$t('datetime.close')"
                >
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-clock</v-icon>
                  </template>
                </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-datetime-picker
                :label="$t('datetime.finalDate')" 
                v-model="dtf"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
                :date-picker-props="dtfProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    fab
                    color="primary darken-1"
                    class="white--text"
                    v-bind="attrs"
                    v-on="on"
                    @click="populaRelatorio"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('operation.search') }}</span>
              </v-tooltip>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <LazySelect
                  ref="linhaSelect"
                  get-url="getLinhaslazy"
                  :request-data="linhaLazyRequestData"
                  text="nome_linha"
                  value="id_linha"
                  :label="$tc('line.self', 1)"
                  :rules="[(v) => !!v || $t('guide.selectLine')]"
                  @input="onLinhaInput"
                />
              </v-col>
            <v-col cols="12" sm="6" md="4">
              <MultiplaEscolha
                ref="trechosSelect"
                :items="trechosSelect"
                v-bind:selected-items.sync="idTrechosSelected"
                text="descricao_completa"
                value="id_trecho"
                :label="$t('relTimeStretch.stretch')"
                :max-items="2"
                :disabled="!idLinhaSelected"
                can-toggle-all
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <MultiplaEscolha
                ref="veiculosSelect"
                lazy
                get-url="getVeiculoslazy"
                :request-data="lazySelectRequestData"
                v-bind:selected-items.sync="idVeiculoSelected"
                text="numero_ordem"
                value="id_veiculo"
                :label="$tc('vehicle.self', 1)"
                :max-items="2"
              />
            </v-col>
            </v-row>
          </v-form>
        </v-container>
  
    <merus-data-table
        :headers="headers"
        :items="trechosFiltered"
        sort-by="inicio"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loading"
        :loading-text="$t('system.messages.loading')"
        :item-class="getColorItem"
        style="border-radius: 10px; margin-bottom: 10px;margin-top: 10px;"
        @update:displayedItems="displayedItemsForExport = $event"
    

 cod-tabela="RELTEMPOTRECHO" @update:headers="headers = $event">
        <template v-slot:toolbar>
            <CadastroToolbar
              :title="$t('nav.reports.stretchTime')"
              :token="token"
              :items="displayedItemsForExport !== null ? displayedItemsForExport : trechosFiltered"
              csv-title="tempodetrecho"
              :csv-headers="headers"
              :pdf-title="$t('nav.reports.stretchTime')"
              :pdf-headers="headers"
              :pdf-subtitle="pdfsubtitle"
              pdf-filename="tempodetrecho"
              hide-search
            />
        </template>

    </merus-data-table>

    </v-container>
  </template>
  
  <script>

  import apiController from "@/utils/apiController";
  import EventBus from "@/utils/eventBus";
  import MerusDataTable from "./Tables/MerusDataTable.vue";
  import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
  import DateUtils from "../utils/dateutils";
  import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
  import LazySelect from './Selects/LazySelect.vue';
  export default {
    components: {
    MerusDataTable,
    CadastroToolbar,
    MultiplaEscolha,
    LazySelect,
},
    data: () => ({
    headers: [],
      displayedItemsForExport: null,
      user: null,
      token: null,
      showConfirmButton: true,
      formValidado: false,
      loading: false,
      timeProps: {
        useSeconds: true,
      },
      dti: null,
      dtf: null,
      idEmpresaSelected:  null,
      idLinhaSelected: null,
      idTrechosSelected: [],
      idVeiculoSelected:  [],
      trechosSelect: [],
      unidadesSelecionadas: [],
      trechos: [],
      trechosFiltered: [],
      config: null,
    }),
    computed: {

      textFieldProps() {
        return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
        };
      },
      headersWithProperties() {
        return this.headers.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
      pdfsubtitle() {
        let subtitle = "";
        if (this.idVeiculoSelected.length > 0) {
          subtitle += `${this.$tc('vehicle.self', 1)}: ${this.idVeiculoSelected.join(', ')} `;
        }
        return subtitle;
      },
      today() {
        return new Date().toISOString().substring(0,10);
      },
      dtiProps() {
        return {
          max: this.today
        }
      },
      dtfProps() {
        let min = null;
        if (this.dti) {
          if (typeof this.dti === 'string') {
            min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
          } else {
            min = this.dti.toISOString().substring(0,10);
          }
        }
        return {
          min: min
        }
      },
      semUnidadeOption() {
        return [
          {
            id_unidade: -1,
            descricao_unidade: 'Sem Unidade',
            cod_unidade: 'SU',
          },
        ];
      },
      linhaLazyExtraData() {
        if (this.unidadesSelecionadas.length !== 1) {
          return {};
        }
        const uid = this.unidadesSelecionadas[0];
        if (uid == null || uid === '' || Number(uid) === -1) {
          return {};
        }
        return { id_unidade: Number(uid) };
      },
      lazySelectRequestData() {
        const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
        const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
        const temSemUnidade = unidades.includes(-1);
        if (reais.length === 1 && !temSemUnidade) {
          return { id_unidade: reais[0] };
        }
        if (temSemUnidade && reais.length === 0) {
          return { id_unidade: -1 };
        }
        return {};
      },
      linhaLazyRequestData() {
        return { ...this.linhaLazyExtraData, ...this.lazySelectRequestData };
      },
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      },
      unidadesSelecionadas() {
        this.resetLazySelectRef('linhaSelect');
        this.idLinhaSelected = null;
        this.limparTrechosSelect();
        if (this.trechos.length > 0) {
          this.aplicarFiltros();
        }
      },
      idVeiculoSelected() {
        if (this.trechos.length > 0) {
          this.aplicarFiltros();
        }
      },
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {},
    methods: {

      initialize() {
        this.getConfig();
      },
      getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
              silent: true,
              onSuccess: (response) => {
                  this.config = response.data[0];
                  [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
              },
              onError: (e) => {
                  console.log("Response : " + e.message);
                  if (e.message == "Request failed with status code 401") {
                    EventBus.$emit('show-error', { error: e });
                  }
              },
          });
        },
      resetLazySelectRef(name) {
        const ref = this.$refs[name];
        if (ref && typeof ref.resetData === 'function') {
          ref.resetData();
        }
      },
      limparTrechosSelect() {
        this.trechosSelect = [];
        this.idTrechosSelected = [];
        this.resetLazySelectRef('trechosSelect');
      },
      populaTrechos(idlinha) {
        if (!idlinha) {
          this.limparTrechosSelect();
          return;
        }
        apiController.request(apiController.endpoints.getTrechosporlinha, {
          params: { id: idlinha },
          onSuccess: (response) => {
            this.trechosSelect = response.data || [];
            const ids = this.trechosSelect.map((t) => t.id_trecho);
            this.idTrechosSelected = ids;
            this.$nextTick(() => {
              if (this.$refs.trechosSelect && typeof this.$refs.trechosSelect.setSelectedItems === 'function') {
                this.$refs.trechosSelect.setSelectedItems(ids);
              }
            });
          },
        });
      },
    aplicarFiltros() {
      let filtrados = this.trechos;

      if (this.unidadesSelecionadas.length > 0) {
        const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
        filtrados = filtrados.filter((t) => {
          return selecionadas.includes(Number(t.id_unidade));
        });
      }

      if (this.idVeiculoSelected.length > 0) {
        const veiculos = this.idVeiculoSelected.map((id) => Number(id));
        filtrados = filtrados.filter((t) => {
          return veiculos.includes(Number(t.id_veiculo));
        });
      }

      this.trechosFiltered = filtrados;
    },
      populaTempoTrecho() {
        const trechosConsulta = this.idTrechosSelected.length > 0
          ? this.trechosSelect.filter((t) => this.idTrechosSelected.some((id) => Number(id) === Number(t.id_trecho)))
          : this.trechosSelect;

        const idtrechos = trechosConsulta.map((t) => t.id_trecho).filter((id) => id != null);
        const idcercas = Array.from(new Set([
          ...trechosConsulta.map((t) => t.id_cerca_inicio_trecho),
          ...trechosConsulta.map((t) => t.id_cerca_fim_trecho),
        ])).filter((id) => id != null);

        // Sem trechos/cercas o SQL gera IN () e quebra; evita a chamada
        if (!idtrechos.length || !idcercas.length) {
          this.trechos = [];
          this.trechosFiltered = [];
          this.loading = false;
          EventBus.$emit('show-alert', {
            tipo: 'warning',
            mensagem: this.$t('relTimeStretch.noStretchesForLine'),
          });
          return;
        }

        this.loading = true;
        let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
        let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

        let body = {
          idtrechos,
          idcercas,
          dti: dataInicial,
          dtf: dataFinal
        }

        apiController.request(apiController.endpoints.getTempotrecho, {
          data: body,
          onSuccess: (response) => {
            this.trechos = response.data;
            this.aplicarFiltros();
            this.loading = false;
          },
          onError: () => {
            this.loading = false;
          },
        });
      },
      populaRelatorio() {
        this.$refs.form.validate();
        if (this.formValidado) {
          this.trechos = [];
          this.trechosFiltered = [];
          this.populaTempoTrecho();
          this.$nextTick(() => { this.$refs.form.resetValidation(); });
        }
      },
      onEmpresaInput(id) {
        this.idEmpresaSelected = id;
        this.idLinhaSelected = null;
        this.limparTrechosSelect();
        this.resetLazySelectRef('linhaSelect');
        this.resetLazySelectRef('veiculosSelect');
        this.idVeiculoSelected = [];
      },
      onLinhaInput(id) {
        this.idLinhaSelected = id;
        this.populaTrechos(id);
      },
      getColorItem(item) {
        if (!item.tempo_trecho) {
          return "trecho__incompleto";
        }

        if (item.tempo_minimo) {
          if (item.tempo_trecho < item.tempo_minimo) {
            return "tempo__abaixo__minimo";
          }
        }

        if (item.tempo_maximo) {
          if (item.tempo_trecho > item.tempo_maximo) {
            return "tempo__acima__maximo";
          }
        }

        return "tempo__ok";
      }
    },
  };
  </script>

<style>
  .tempo__abaixo__minimo {
    color: darkorange;
    font-weight: bold;
  }

  .tempo__acima__maximo {
    color: red;
    font-weight: bold;
  }

  .tempo__ok {
    color: green;
    font-weight: bold;
  }

  .trecho__incompleto {
    color: #4a4a4a;
  }
</style>
